var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Prison(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 54.92V70H38.17V54.92a4.92 4.92 0 015-4.92H52v15.74l1.5 1.58 1.5-1.65V50h8a4.93 4.93 0 015 4.92zM42.39 31.58l11.08-8.08 11.09 8-2.79 3.5H45.18l-2.79-3.42zM51.47 30a2 2 0 104 0 2 2 0 00-4 0zm-6.21 8a8.379 8.379 0 1016.43 0H45.26zM39 45H6V10h36.93v16l-3.43 3H34v12h5v4zm-5-19h5.11L39 14h-5v12zm-19 3h-5v12h5V29zm0-15h-5v12h5V14zm8 15h-5v12h5V29zm0-15h-5v12h5V14zm8 15h-5v12h5V29zm0-15h-5v12h5V14z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Prison.26276f56.svg";
export { SvgG1Prison as ReactComponent };